import { render, staticRenderFns } from "./hokl_hosm_mail_header.vue?vue&type=template&id=49fb13bb&scoped=true"
import script from "./hokl_hosm_mail_header.vue?vue&type=script&lang=js"
export * from "./hokl_hosm_mail_header.vue?vue&type=script&lang=js"
import style0 from "./hokl_hosm_mail_header.vue?vue&type=style&index=0&id=49fb13bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb13bb",
  null
  
)

export default component.exports